module.exports = __webpack_public_path__ + "images/stickers/star.4c68ea50e4ffeeb97df5.png";